import { default as _91_46_46_46slug_938peGIpxhV8Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/[...slug].vue?macro=true";
import { default as indexdNJZf111djMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/auth/index.vue?macro=true";
import { default as indexjqQNArpqo9Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93p676CJCxb6Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93UvnsYlBURcMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93SaNAWS01e4Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_931cVLWEDnEcMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/news/[slug].vue?macro=true";
import { default as organisationsnjRtT5JyVfMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsuF8jCltn7NMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programsOtzweyNKTYMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexibMuyS5vibMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/processes/index.vue?macro=true";
import { default as dungeonBcrCh47VVcMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsa5IGtJTINDMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexiWg2vgcn4ZMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/secret/index.vue?macro=true";
import { default as index7TEQ4iriblMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDataoiUYFHvmW7Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassb2ra13QoOqMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_932j3s4TXqJOMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexyJTn4UXwtpMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataKBvy5ny9cNMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldsTYIQzmQjRAMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsWUHjkdG9YjMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsgf5aBgcfcNMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93yaLDmznLoMMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as index1s7Lph6MRuMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesI9AyXC6SlKMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDataJSTodCfmVWMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93GGe6HTlJewMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexo43ePZocH4Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesg8McpFbhpAMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDataa8Ml3ZzCMIMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93VlxUTX7GmoMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexMP94V91SySMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseData4HrmjBcMcCMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93gqtA96VzkIMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as indexstN64FTwrbMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataupbHxUTWljMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassIDY5P1v1ITMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedFormsrHiDDHGr3FMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_93k3rTg1PGyMMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as indexIc8jV5QelJMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiesWv4V2p9kO2Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDatahZMBVEIlYOMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriods96flPYFRAcMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_937ecTDUePioMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as indexchKXQY4rIzMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivitiesgQ3lEYJS9IMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseDatayYRdjzlQs1Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotificationsS70RVWW0kgMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93uOD7jgziD9Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as index6jgXtgCyK3Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataDJeI9xpFWjMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDatajbdEl2dkQxMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93pxzOqu0GLdMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexKR8Ollyo9jMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicDataT5vx0JEOisMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93hpiCy3xX4FMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexicDpqso9LSMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroups4lrOi9MrbcMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDatawTcXKQEZfpMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93XtlHaP00AGMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexuDZoGkACogMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parisheszAIlN4bHniMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesekjfX60TYBMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsr5XmW0zR8bMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDatanuJDOnHx1FMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconias7nWI7Imo3ZMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesqV1bCGOLI8Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_933pXOBru0mzMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexorOp30eDwQMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsQWPG6gIDtwMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltfVJ51J2wXlMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDataJTt5H4xLRhMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsUplKOeuQkJMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93ZqaAG3orHOMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexfxJbWKSYW2Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as payments7PXuJLWM4PMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/payments.vue?macro=true";
import { default as processActivities80SxujdYzmMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseDatakVkYCSm9xbMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93V8v98lUKvyMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/processes/[id].vue?macro=true";
import { default as index9WrKunhm0fMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovalTgTtY2nlhZMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93q1bS9CBeTdMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexsJpTdYPRxSMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersVn7bYujhYXMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitiessq37bBdRDtMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettingsTLLjx7WMadMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDataVN1YIgBcVjMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesi6oWOrg3xmMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConcept3WQgWGiC6JMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementm4Ua7LkUQiMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUserstEAzCHVjVeMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93Lnd6FSjMlhMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexUEaUeKEsiCMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationszxZpziPyt6Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesdvfvV5xZEpMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseData2Ei2kv8UY8Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFilters67qrx0ceN8Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignatureHM3OWXBSnuMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_936QdhtS9w0qMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexQHcLoM7OleMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersUoSIUzuM27Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users.vue?macro=true";
import { default as settingsgZrbqim2O8Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivities5lCdHGaduCMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDatapA5R53FoZWMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93qPcuLrojLbMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as index3PVamQwwMIMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as servicePcWF20mIIYMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service.vue?macro=true";
import { default as languageo5MYVd2acQMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDatafPz0A4TSRJMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategories9oFErn928MMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreement8uXn0TY8fAMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersYxhKCHVuz1Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93lx9PHpysBCMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDataaR8kOHhvTlMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignatureGYRgRHMxptMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93sZfai8hjNZMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/users/[id].vue?macro=true";
import { default as indexiXhv9RUsefMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/users/index.vue?macro=true";
import { default as settingsH4XmgwvedpMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings.vue?macro=true";
import { default as signatureztCn9pqG9VMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/signature.vue?macro=true";
import { default as sportbizzruMdhrKmIhMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93w6HRZohwq2Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93xMggN4fHd8Meta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexGB237pRz7AMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93JCCRZGg7ClMeta } from "/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_938peGIpxhV8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexdNJZf111djMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexjqQNArpqo9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93p676CJCxb6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93UvnsYlBURcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93SaNAWS01e4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationsnjRtT5JyVfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexibMuyS5vibMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: servicePcWF20mIIYMeta?.name,
    path: "/service",
    meta: servicePcWF20mIIYMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicDataT5vx0JEOisMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: index7TEQ4iriblMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_932j3s4TXqJOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexyJTn4UXwtpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93yaLDmznLoMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: index1s7Lph6MRuMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93GGe6HTlJewMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexo43ePZocH4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93VlxUTX7GmoMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexMP94V91SySMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93gqtA96VzkIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: indexstN64FTwrbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_93k3rTg1PGyMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: indexIc8jV5QelJMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_937ecTDUePioMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: indexchKXQY4rIzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93uOD7jgziD9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotificationsS70RVWW0kgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: index6jgXtgCyK3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93pxzOqu0GLdMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexKR8Ollyo9jMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93hpiCy3xX4FMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parisheszAIlN4bHniMeta?.name,
    path: "parishes",
    meta: parisheszAIlN4bHniMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93XtlHaP00AGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsQWPG6gIDtwMeta?.name,
    path: "regions",
    meta: regionsQWPG6gIDtwMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_933pXOBru0mzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: payments7PXuJLWM4PMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93ZqaAG3orHOMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexfxJbWKSYW2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93V8v98lUKvyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: index9WrKunhm0fMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovalTgTtY2nlhZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsgZrbqim2O8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersVn7bYujhYXMeta?.name,
    path: "loginProviders",
    meta: loginProvidersVn7bYujhYXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93q1bS9CBeTdMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexsJpTdYPRxSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationszxZpziPyt6Meta?.name,
    path: "organisations",
    meta: organisationszxZpziPyt6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93Lnd6FSjMlhMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexUEaUeKEsiCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersUoSIUzuM27Meta?.name,
    path: "users",
    meta: usersUoSIUzuM27Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_936QdhtS9w0qMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexQHcLoM7OleMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93qPcuLrojLbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: index3PVamQwwMIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsH4XmgwvedpMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93lx9PHpysBCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93sZfai8hjNZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: indexiXhv9RUsefMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signatureztCn9pqG9VMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzruMdhrKmIhMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93w6HRZohwq2Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93xMggN4fHd8Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexGB237pRz7AMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93JCCRZGg7ClMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250627104824/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]